<div class="cad-page">
  <header class="cad-page__header">
    <div>
      <h4 class="cad-page__title">CAD Viewer</h4>
      <p class="cad-page__subtitle">Upload and review AutoCAD DWG / DXF drawings in the browser.</p>
    </div>
  </header>

  <div class="cad-page__body">
    <aside class="cad-page__sidebar">
      <app-cad-drawing-list
        contextType="standalone"
        title="My drawings"
        [selectMode]="true"
        [selectedId]="selected?.id ?? null"
        (select)="onSelect($event)"
        (drawingsChange)="onDrawingsChange($event)"
      ></app-cad-drawing-list>
    </aside>

    <section class="cad-page__viewer">
      <div class="cad-page__viewer-title" *ngIf="selected">
        <i class="bi bi-file-earmark-ruled"></i>
        <span>{{ selected.original_name }}</span>
      </div>
      <app-cad-viewer-canvas class="cad-page__canvas" [drawing]="selected"></app-cad-viewer-canvas>
    </section>
  </div>
</div>
